"use strict";
import { BusEvents } from "@/types";
export default function onWalletConnected(callback) {
  onMounted(() => {
    callback();
    useEventBus(BusEvents.WalletConnected).on(() => callback());
  });
}
